import ApiAdmin from './config/ApiAdmin'
import _ from 'lodash'
import store from '@/store/index'

const TestsService = {

  getTests (page, pageSize, search) {
    return ApiAdmin.get(`/organizations/${store.getters.slug}/tests`,
      {params: {page, page_size: pageSize, search}})
  },

  getTestsByGroupId (groupId) {
    return ApiAdmin.get(`/groups/${groupId}/tests`)
  },

  getTest (orgSlug, testId) {
    return ApiAdmin.get(`/organizations/${orgSlug}/tests/${testId}`)
  },

  createTest (test) {
    return ApiAdmin.post(`/organizations/${store.getters.slug}/tests`, test)
  },

  patchTest (test) {
    let newTest = _.clone(test, true)
    delete newTest.test_questions
    console.log(newTest)
    return ApiAdmin.patch(`/tests/${test.id}`, newTest)
  },

  removeTestFromGroup (groupId, testId) {
    return ApiAdmin.delete(`/groups/${groupId}/tests/${testId}`)
  },

  addTestToGroup (groupId, testId) {
    return ApiAdmin.put(`/groups/${groupId}/tests/${testId}`)
  },

  getTestResultByPlayerIdAndTestId (playerId, resultId) {
    return ApiAdmin.get(
      `/organizations/${store.getters.slug}/players/${playerId}/results/${resultId}`)
  },

  getTestResultByPlayerIdAndTestIdAndSlug (playerId, resultId, slug) {
    return ApiAdmin.get(
      `/organizations/${slug}/players/${playerId}/results/${resultId}`)
  },

  getTestResultsByPlayerId (slug, playerId) {
    return ApiAdmin.get(
      `/organizations/${slug}/players/${playerId}/results`)
  },

  getTestResultsByPlayerIdAndGroupId (slug, playerId, testId) {
    return ApiAdmin.get(
      `/organizations/${slug}/players/${playerId}/tests/${testId}/results`)
  },

  getTestResultsByGroupId (groupId, testId, page, pageSize, search) {
    return ApiAdmin.get(
      `/organizations/${store.getters.slug}/groups/${groupId}/tests/${testId}/results`, {
        params: {
          page,
          page_size: pageSize,
          search
        }
      })
  },

  /* игра */
  postStartTest (orgSlug, playerId, testId) {
    return ApiAdmin.post(`/organizations/${orgSlug}/tests/${testId}/start`,
      {player: playerId, test: testId})
  },

  postEndTest (orgSlug, playerId, testId, payload) {
    return ApiAdmin.post(`/organizations/${orgSlug}/tests/${testId}/end`,
      {player: playerId, test: testId, payload})
  }

}
export default TestsService



// WEBPACK FOOTER //
// ./src/services/TestsService.js